import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicRichText, PrismicLink } from '@prismicio/react'

const BannerWithCaption = ({ slice }) => {
  let data = slice.primary || slice
  return (
    <section className='component-banner_with_caption mx-auto max-w-screen-xl p-6'>
      <div className='relative mb-4 bg-blue-900 md:mb-12'>
        {data.image.gatsbyImageData && (
          <div className='relative right-0 h-32 sm:h-72 md:absolute md:h-full md:w-1/2'>
            <GatsbyImage image={data.image.gatsbyImageData} className='h-full w-full object-cover' alt={data.image.alt || ''} />
            <div aria-hidden='true' className='absolute inset-0 h-full w-full bg-gradient-to-t from-blue-900 md:bg-gradient-to-r'></div>
          </div>
        )}
        <div className=''>
          <div className='prose prose-lg relative inset-0 mx-auto max-w-screen-xl p-4 md:py-20 lg:py-32'>
            {data.title && <PrismicRichText field={data.title.richText} />}
            {data.text && <PrismicRichText field={data.text.richText} />}
            {data.button_link.url && (
              <div className='mt-auto flex'>
                <PrismicLink className='button brand rounded text-lg' href={data.button_link.url}>
                  {data.button_text}
                </PrismicLink>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BannerWithCaption
